export default {
  title: 'Kaart toevoegen',
  buttons: {
    save: 'Opslaan',
  },
  feedback: {
    success: 'Kaart succesvol opgeslagen',
  },
};
